import React, { Component } from 'react';
import css from './style.css';
import CSSModule from 'react-css-modules';
import { connect } from 'react-redux';
import cookie from 'react-cookie';

import { getBills, cancelContract, getOneBills } from '../../actions';

import TextFeild from '../../component/textFeild';
import Title from '../../component/title';
import $ from 'jquery';
import { browserHistory } from 'react-router'
import Button from '../../component/button';
import Bill from '../../component/bill_full';
import { Modal } from 'antd';
import moment from 'moment';
import Board from './board';

class Manage extends Component {
	constructor(props) {
		super(props);
		//console.log(props);
        const user_id = cookie.load('user_id');
        props.getBills();

		this.cancelContract = (serial_no) => {
			this.props.cancelContract({ serial_no: serial_no}).then((res) => {
				alert("退費完成，退款會回沖到您的下棋信用卡帳單");
				location.reload();
			});
		}

		this.onSelect = (data) => {

			if( this.currentShow  === data.id ) return false;

			this.currentShow = data.id;

			if(!data.remark) {
				this.props.getOneBills({ contract_id: data.id}).then((res)=>{
					if( res[0] ) {

						Modal.info({
							title: `訂單明細`,
							content: this.renderInfo(res[0]),
							maskClosable: true,
							onCancel: (e) => {
								this.currentShow = 0;
							}
						})
						
					}
					
				});
			}
			else {
				Modal.info({
					title: `訂單明細`,
					content: this.renderInfo(data),
					maskClosable: true,
					onCancel: (e) => {
						this.currentShow = 0;
					}
				})
			}
		}
	}

	renderInfo(data) {

		return <Board data={data} cancelAction={this.cancelContract} studentsEntity={this.props.studentsEntity}/>;
		
	}
	render() {
        const { bills, user_points } = this.props;
		
		const data = bills.concat( user_points && user_points.filter((object)=> object.remark === '推薦贈送點數'));
		//console.log(bills);
		return (
			<div styleName="">
				<Title>訂單與課程扣點記錄</Title>
                    {data && <Bill data={data} onSelect={this.onSelect}/> }
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
        bills: state.data.bills,
		studentsEntity: state.data.studentsEntity,
		user_points: state.data.user.points || []
    };
}

export default connect(mapStateToProps, { getBills, cancelContract, getOneBills })(CSSModule(Manage,css, {allowMultiple:true}));




/** WEBPACK FOOTER **
 ** ./src/container/manage/index.js
 **/